import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import logo from "../../assets/logo.png";
import { instagram, blog, linkedin, twitter, learn } from "../../assets/social";
import { Popup } from "../helpers/Popup";
import { ResumeChoice } from "../helpers/ResumeChoicePopup";
import { privacyData, tou } from "../../helpers/constant";
import { Container, Description, ResumePlaceholder, MenuBar, TagLine, SubTag, Button, Social, A, CvImg, Img, ImageHolder, LinkStyled, LinksWrapper, SiteTitle } from "./styles";

const LandingPage = () => {
    const [popUp, setPopUp] = useState(false);
    const [resumeChoice,setResumeChoice]=useState(false);
    useEffect(() => {
        if (!((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1))) {
            let card = document.querySelector('.card');
            document.addEventListener('mousemove', function (e) {
                let xAxis = (window.innerWidth / 2 - e.pageX) / 32;
                let yAxis = (window.innerHeight / 2 - e.pageY) / 32;
                card.style.transform = `rotateY(${xAxis}deg) rotateX(${yAxis}deg)`;
            });
        }
        return () => window.removeEventListener("mousemove", () => { })
    }, []);

    return (
        <Container>
            <Description>
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta name="viewport" content="width=device-width,height=device-height, initial-scale=1, maximum-scale=2, minimum-scale=0.25, user-scalable=yes" />
                </Helmet>
                <MenuBar>
                    <A href="/" noreferrer><img src={logo} alt="logo" style={{ height: "60px" }} /></A>
                    <SiteTitle>RESUMO</SiteTitle>
                </MenuBar>
                <TagLine>
                    Create your Resume with Live Editor for Free.
                    <SubTag>No signin Required. We are 100% Free</SubTag>
                    <Button onClick={()=>setResumeChoice(true)} className="glow-on-hover">Create Resume</Button>
                </TagLine>
                <Social>
                    <A href="https://www.linkedin.com/in/parthmakadiya007/" target="_blank" noreferrer>
                        <Img src={linkedin} alt="logo" /></A>
                    <A href="https://twitter.com/parthmakadiya12" target="_blank" noreferrer>
                        <Img src={twitter} alt="logo" /></A>
                    <A href="https://www.instagram.com/parthmakadiya/" target="_blank" noreferrer>
                        <Img src={instagram} alt="logo" /></A>
                    <A href="http://alltricks007.blogspot.com/" target="_blank" noreferrer>
                        <Img src={blog} alt="logo" />
                    </A>
                    <A href="https://blog.resumo.in/docs/" target="_blank" noreferrer>
                        <Img src={learn} alt="logo" /></A>
                </Social>
            </Description>
            <ResumePlaceholder>
                <ImageHolder className="card">
                    <CvImg src={require(Math.round(Math.random()) ? "../../assets/creativo.jpg" : "../../assets/fantastico.jpg")} alt="resume image" />
                </ImageHolder>
            </ResumePlaceholder>
            <LinksWrapper>
                <LinkStyled href="https://blog.resumo.in/docs/" target="_blank" noreferrer>Development</LinkStyled>
                <LinkStyled href="https://www.buymeacoff.ee/parthmakadiya12" target="_blank" noreferrer>Buy me a Coffee</LinkStyled>
                <LinkStyled onClick={(e) => setPopUp(privacyData)}>Privacy Policy</LinkStyled>
                <LinkStyled onClick={(e) => setPopUp(tou)}>Terms of Use</LinkStyled>
            </LinksWrapper>
            {
                popUp &&
                <Popup header={popUp.header} text={popUp.text} closePopup={() => setPopUp(false)} />
            }
            {
                resumeChoice &&
                <ResumeChoice closePopup={() => setResumeChoice(false)}/>
            }
        </Container>
    )
};

export default LandingPage;